const enGB = {
    'global': {
        'default': {
            'refresh': 'Refresh',
            'all': 'All',
        },
    },
    'TopdataContactLoginSW6': {
        'conversionLog': {
            'module': {
                'name': 'Customer Conversions',
                'title': 'Customer Conversions',
                'description': 'Log of conversions from standalone customer accounts to B2B contacts',
            },
            'list': {
                'title': 'Customer Conversions',
                'searchEmailPlaceholder': 'Search by source email…',
                'filter': {
                    'triggeredBy': 'Triggered by',
                },
                'column': {
                    'createdAt': 'Date',
                    'sourceCustomerEmail': 'Source Email',
                    'sourceCustomerName': 'Source Name',
                    'targetCustomerNumber': 'Target Customer Number',
                    'ordersTransferred': 'Orders',
                    'contactsMoved': 'Contacts Moved',
                    'contactsDeleted': 'Contacts Deleted',
                    'triggeredBy': 'Triggered by',
                },
            },
            'triggeredBy': {
                'cli': 'CLI',
                'admin_api': 'Administration',
                'api': 'API (external)',
            },
        },
    },
};

export default enGB;
